import { usePrizesStore } from '@/stores/prizes'
import { useUserStore } from '@/stores/user'
import { type SiteSlug, ThemeType, getTheme } from '@goodlifeplus/themes'
import type { RouteLocation, RouteLocationRaw } from 'vue-router'

/**
 * Guard for the prize route on the subscription theme.
 * Logged-out users are sent to the prize's own campaign lead page so they can
 * still enter for free. Falls back to memberships if the prize has no campaign.
 * The prize fetch here is cheap — the prizes store caches the result, so the
 * subsequent beforeRoutePrizeUpdate guard reuses it.
 */
export default async function subscriptionPrizeAuthGuard(
  to: RouteLocation
): Promise<RouteLocationRaw | boolean> {
  const isSubscription =
    getTheme(import.meta.env.GLP_SITE_SLUG as SiteSlug).type ===
    ThemeType.Subscription

  if (!isSubscription || useUserStore().isLoggedIn) {
    return true
  }

  const prize = await usePrizesStore().fetchPrize(
    to.params.prizeCode as string,
    true
  )

  if (prize?.campaign_code) {
    return {
      name: 'campaign',
      params: { campaignCode: prize.campaign_code },
      query: { redirect: to.params.prizeCode as string },
    }
  }

  return { name: 'memberships' }
}
